import React from 'react';
import { Helmet } from 'react-helmet';
import { MainNavigation } from '@/components/MainNavigation';
import { GridBackground } from '@/components/GridBackground';
import { TopBanner } from '@/components/TopBanner';
import { Hero } from '@/components/Hero';
import { AccessInfoSection } from '@/components/AccessInfoSection';
import { DomainGrid } from '@/components/DomainGrid';
import { SecuritySection } from '@/components/SecuritySection';
import { SupportSection } from '@/components/SupportSection';
import { WhyChooseSection } from '@/components/WhyChooseSection';
import { QuickAnswerSection } from '@/components/QuickAnswerSection';
import { SmartRegionalSection } from '@/components/SmartRegionalSection';
import { GateFAQSection } from '@/components/GateFAQSection';
import { GatePageSchema } from '@/components/GatePageSchema';
import { Footer } from '@/components/Footer';
import { gatePageAIO } from '@/data/gatePageAIO';
import { SmartSportsWidget } from '@/components/Sports/SmartSportsWidget';
import { LiveMatchTicker } from '@/components/Sports/LiveMatchTicker';

export const GatePage = () => {
  return (
    <div className="min-h-screen relative">
      <Helmet>
        <title>XtreamGate - Official XtreamCube Gateway | Best IPTV Service 2026</title>
        <meta name="description" content="Official XtreamCube Gateway. Best IPTV service provider 2026. Premium IPTV subscription with 20,000+ channels, 4K streaming, 25 global servers, and 24/7 support. Join 27.5K+ customers." />
        <meta name="keywords" content="XtreamCube, XtreamCube login, XtreamCube official, best IPTV service 2026, IPTV provider, live TV streaming, 4K IPTV, IPTV subscription" />
        <meta property="og:title" content="XtreamGate - Official XtreamCube Gateway" />
        <meta property="og:description" content="Premium IPTV service with 20,000+ channels and 4K quality" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://xtreamgate.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="XtreamGate - Official IPTV Service" />
        <meta name="twitter:description" content="Best IPTV service provider 2026 with premium features" />
      </Helmet>
      <GatePageSchema faqItems={gatePageAIO.faqItems} />
      <GridBackground />
      <TopBanner />
      <MainNavigation />
      <LiveMatchTicker />
      <main>
        <Hero />
        <SmartSportsWidget />
        <QuickAnswerSection answer={gatePageAIO.quickAnswer} />
        <AccessInfoSection />
        <DomainGrid />
        <WhyChooseSection />
        <SmartRegionalSection />
        <SecuritySection />
        <GateFAQSection faqItems={gatePageAIO.faqItems} />
        <SupportSection />
      </main>
      <Footer />
    </div>
  );
};